/*---------------------------------------------------------------------------------------------
 *  Copyright (c) by Solusek Systems. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import Globals from "../shared/Globals";
import { qreq } from "../shared/qrequest";
import BaseCom from "./BaseCom";
import Card from "./Card";
import { withParamsAndNavigate } from "./WithParamsAndNavigate";

class Eligibility extends BaseCom {
    constructor(props) {
        super(props);
        this.state = {};
    }

    async componentDidMount() {
        await this.load();
    }

    load = async () => {
        try {
            const j = await qreq.getAsync('/api/insurance/eligibility/response/list?orderID=' + this.props.order.id);
            if (j.list) {
                this.setState({ list: j.list });
            }
            else
                this.alert(j.errorMessage);
        }
        catch (e) {
            this.unkownErrorCallback(e);
        }
    }

    componentDidUpdate(prevProps) {
    }

    componentWillUnmount() {
    }

    render() {
        return <div>
            {this.state.list?.map((i, idx) => <div key={idx}>
                <Card title="Eligibility Response">
                    <div><strong>{Globals.toMDYHMLocalDateStringOrDiff(i.createdDate)}</strong></div>
                    {i.errors.map((j, jdx) => <div key={jdx}>
                        {j.rejectReasonDescription}
                    </div>)}
                </Card>
            </div>)}
        </div>;
    }
}

export default withParamsAndNavigate(Eligibility);